module.exports = __webpack_public_path__ + "static/img/a024.22cdf24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a024.jpg
// module id = xxDf
// module chunks = 0